module.exports = __webpack_public_path__ + "static/media/hexagan-success-tick.8675ad15.svg";